import { object, string } from 'yup';

/**
 * Contact form schema
 * Shared with react-hook-form and used to validate input server side with yup
 */
export const contactFormSchema = object().shape({
  enquiryType: string().required('Please select an enquiry type'),
  firstName: string().required('Please enter your first name'),
  lastName: string().required('Please enter your last name'),
  phone: string().required('Please enter your phone number'),
  email: string()
    .email('Please enter a valid email address')
    .required('Please enter your email address'),
  message: string().required('Please enter a message'),
  location: string(),
});
